export const navItems = [
  { id: 'top', label: '首页' },
  { id: 'picks', label: '编辑精选' },
  { id: 'category', label: '题材速览' },
  { id: 'library', label: '热映片单' },
  { id: 'ranking', label: '热看榜' },
  { id: 'talk', label: '影迷话题' },
  { id: 'columns', label: '观影指南' },
];

export const tickerItems = [
  '《盛夏的橘子树》片尾彩蛋曝光，观众直呼回到高中夏天',
  '暑期档青春片单更新：22 部校园片一次看够',
  '本周热门短评：「初恋电影就该拍成青柠汽水的味道」',
  '新人导演单元上线，8 部小清新处女作免费试看',
];

export const heroStats = [
  { value: '12,860', label: '青春影片库' },
  { value: '340', label: '精编片单' },
  { value: '58.6万', label: '影迷短评' },
  { value: '96%', label: '轻松治愈率' },
];

export const heroTags = [
  '校园片',
  '初恋电影',
  '清纯少女',
  '小清新',
  '治愈系',
  '青春怀旧',
  '夏日限定',
];

export const heroPosters = [
  {
    id: 'hp-1',
    title: '盛夏的橘子树',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20film%20poster%20art%20of%20a%20sunlit%20orchard%20with%20green%20orange%20trees%2C%20soft%20warm%20light%2C%20young%20couple%20silhouette%20in%20distance%2C%20clean%20cream%20background%2C%20delicate%20illustrated%20style%2C%20nostalgic%20summer%20mood&width=500&height=750&seq=qpg-poster-summer-orange&orientation=portrait',
  },
  {
    id: 'hp-2',
    title: '校服第二颗纽扣',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20film%20poster%20of%20a%20school%20uniform%20collar%20detail%20with%20a%20single%20white%20button%2C%20soft%20pastel%20green%20background%2C%20clean%20editorial%20composition%2C%20gentle%20lighting%2C%20youthful%20and%20fresh%20mood&width=500&height=750&seq=qpg-poster-uniform-button&orientation=portrait',
  },
  {
    id: 'hp-3',
    title: '晚自习的猫',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20film%20poster%20of%20a%20cat%20sleeping%20on%20a%20desk%20under%20warm%20classroom%20lamp%20light%2C%20soft%20green%20and%20cream%20tones%2C%20quiet%20evening%20atmosphere%2C%20clean%20illustrated%20style&width=500&height=750&seq=qpg-poster-cat-study&orientation=portrait',
  },
];

export const editorPicks = [
  {
    id: 'ep-main',
    tag: '本周头条',
    title: '从青涩校园恋曲到清新纯爱：这个夏天最值得重温的青春片单',
    excerpt:
      '我们按「心动瞬间」重新排了一次片单——没有狗血，只有粉笔灰、单车铃声和没说出口的喜欢。适合一个人安静看完，也适合约上当年那个同桌。',
    meta: '编辑 · 林小满',
    read: '8 分钟读完',
    image: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20scene%20of%20a%20school%20corridor%20with%20sunlight%20through%20windows%2C%20green%20trees%20outside%2C%20empty%20desks%20and%20chalk%20dust%20in%20the%20air%2C%20soft%20cinematic%20tones%2C%20clean%20editorial%20photography&width=960&height=640&seq=qpg-editor-main-campus&orientation=landscape',
  },
  {
    id: 'ep-1',
    tag: '初恋电影',
    title: '《青柠汽水》为什么被称作「小清新正确打开方式」',
    meta: '编辑 · 阿柚',
  },
  {
    id: 'ep-2',
    tag: '清纯少女',
    title: '五位新人女主，撑起了今年最好看的校园片',
    meta: '编辑 · 木南',
  },
  {
    id: 'ep-3',
    tag: '治愈系',
    title: '情绪低气压时的五部解药：看完想给十七岁的自己写信',
    meta: '编辑 · 大麦',
  },
  {
    id: 'ep-4',
    tag: '青春怀旧',
    title: '那些年我们租过的碟：青春片里的时代物件考',
    meta: '编辑 · 老周',
  },
];

export const categories = [
  { id: 'c1', name: '校园片', count: 3860, image: 'https://readdy.ai/api/search-image?query=Bright%20green%20school%20playground%20with%20empty%20basketball%20court%20and%20sunlit%20trees%2C%20clean%20minimal%20editorial%20photo%2C%20fresh%20summer%20tones&width=640&height=480&seq=qpg-cat-campus&orientation=landscape' },
  { id: 'c2', name: '初恋电影', count: 2410, image: 'https://readdy.ai/api/search-image?query=Two%20bicycles%20parked%20side%20by%20side%20under%20a%20green%20tree%20with%20warm%20afternoon%20light%2C%20clean%20minimal%20composition%2C%20soft%20fresh%20tones&width=640&height=480&seq=qpg-cat-firstlove&orientation=landscape' },
  { id: 'c3', name: '小清新', count: 1980, image: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20lay%20of%20a%20lime%20soda%20glass%20with%20ice%20on%20a%20cream%20table%2C%20soft%20natural%20light%2C%20clean%20fresh%20aesthetic%20photography&width=640&height=480&seq=qpg-cat-fresh&orientation=landscape' },
  { id: 'c4', name: '清纯少女', count: 1520, image: 'https://readdy.ai/api/search-image?query=Soft%20window%20light%20on%20a%20white%20curtain%20with%20green%20plants%2C%20delicate%20clean%20aesthetic%2C%20pastel%20fresh%20tones%2C%20minimal%20editorial%20photo&width=640&height=480&seq=qpg-cat-girl&orientation=landscape' },
  { id: 'c5', name: '治愈系', count: 1340, image: 'https://readdy.ai/api/search-image?query=A%20cat%20sleeping%20on%20a%20sunny%20windowsill%20beside%20green%20plants%2C%20warm%20soft%20light%2C%20clean%20cozy%20minimal%20aesthetic%20photography&width=640&height=480&seq=qpg-cat-heal&orientation=landscape' },
  { id: 'c6', name: '夏日限定', count: 1120, image: 'https://readdy.ai/api/search-image?query=Seaside%20breeze%20on%20a%20sunny%20afternoon%20with%20blue-green%20waves%20and%20clean%20sky%2C%20minimal%20fresh%20aesthetic%20photo%2C%20soft%20summer%20tones&width=640&height=480&seq=qpg-cat-summer&orientation=landscape' },
  { id: 'c7', name: '青春怀旧', count: 980, image: 'https://readdy.ai/api/search-image?query=Old%20cassette%20player%20and%20stack%20of%20CDs%20on%20a%20wooden%20desk%20with%20warm%20light%2C%20nostalgic%20clean%20minimal%20still%20life%20photography&width=640&height=480&seq=qpg-cat-nostalgia&orientation=landscape' },
  { id: 'c8', name: '青春喜剧', count: 860, image: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20confetti%20and%20paper%20planes%20on%20a%20clean%20light%20background%2C%20playful%20minimal%20flat%20lay%2C%20fresh%20vivid%20tones&width=640&height=480&seq=qpg-cat-comedy&orientation=landscape' },
];

export const libraryFilms = [
  {
    id: 'f1',
    title: '盛夏的橘子树',
    subtitle: '转学生与果园少年的第三个夏天',
    score: '9.1',
    year: '2026',
    duration: '112 分钟',
    tags: ['校园片', '夏日限定'],
    comments: '2.4万',
    image: 'https://readdy.ai/api/search-image?query=Two%20teenagers%20sitting%20under%20a%20green%20orange%20tree%20in%20a%20sunny%20orchard%2C%20warm%20nostalgic%20summer%20light%2C%20cinematic%20soft%20focus%2C%20clean%20fresh%20tones&width=760&height=520&seq=qpg-film-orange-tree&orientation=landscape',
  },
  {
    id: 'f2',
    title: '青柠汽水',
    subtitle: '一杯汽水，一段没说的话',
    score: '8.8',
    year: '2025',
    duration: '98 分钟',
    tags: ['小清新', '初恋电影'],
    comments: '1.8万',
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20glass%20of%20lime%20soda%20with%20ice%20and%20bubbles%20on%20a%20cream%20table%2C%20soft%20natural%20light%2C%20clean%20fresh%20minimal%20photography&width=500&height=340&seq=qpg-film-lime-soda&orientation=landscape',
  },
  {
    id: 'f3',
    title: '晚自习的猫',
    subtitle: '教室最后一排的秘密听众',
    score: '8.6',
    year: '2025',
    duration: '104 分钟',
    tags: ['治愈系', '校园片'],
    comments: '9600',
    image: 'https://readdy.ai/api/search-image?query=A%20cat%20curled%20up%20on%20a%20classroom%20desk%20at%20night%20under%20warm%20lamp%20light%2C%20quiet%20cozy%20atmosphere%2C%20soft%20green%20tones%2C%20clean%20cinematic%20style&width=500&height=340&seq=qpg-film-cat-class&orientation=landscape',
  },
  {
    id: 'f4',
    title: '校服第二颗纽扣',
    subtitle: '关于毕业前的那颗扣子',
    score: '8.4',
    year: '2024',
    duration: '96 分钟',
    tags: ['校园片', '青春怀旧'],
    comments: '1.2万',
    image: 'https://readdy.ai/api/search-image?query=Detail%20of%20a%20white%20school%20uniform%20button%20held%20in%20hand%2C%20soft%20pastel%20background%2C%20gentle%20light%2C%20minimal%20clean%20editorial%20photography&width=500&height=340&seq=qpg-film-button&orientation=landscape',
  },
  {
    id: 'f5',
    title: '樱花落下的速度',
    subtitle: '每秒五厘米的告别',
    score: '8.9',
    year: '2025',
    duration: '108 分钟',
    tags: ['初恋电影', '小清新'],
    comments: '2.1万',
    image: 'https://readdy.ai/api/search-image?query=Falling%20pink%20cherry%20blossoms%20in%20soft%20spring%20light%20against%20a%20clean%20pale%20sky%2C%20delicate%20minimal%20aesthetic%2C%20gentle%20fresh%20tones&width=500&height=340&seq=qpg-film-sakura&orientation=landscape',
  },
  {
    id: 'f6',
    title: '操场尽头的告白信',
    subtitle: '把喜欢折成纸飞机',
    score: '8.2',
    year: '2024',
    duration: '92 分钟',
    tags: ['清纯少女', '校园片'],
    comments: '8700',
    image: 'https://readdy.ai/api/search-image?query=A%20folded%20paper%20letter%20and%20paper%20airplane%20on%20an%20empty%20running%20track%2C%20golden%20afternoon%20light%2C%20clean%20minimal%20nostalgic%20photography&width=500&height=340&seq=qpg-film-letter&orientation=landscape',
  },
  {
    id: 'f7',
    title: '旧相机里的夏天',
    subtitle: '一卷没洗出来的胶片',
    score: '8.5',
    year: '2025',
    duration: '101 分钟',
    tags: ['青春怀旧', '治愈系'],
    comments: '1.1万',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20camera%20and%20photo%20prints%20on%20a%20wooden%20table%20with%20warm%20sunlight%2C%20nostalgic%20clean%20still%20life%2C%20soft%20tones&width=500&height=340&seq=qpg-film-camera&orientation=landscape',
  },
  {
    id: 'f8',
    title: '天台上的三万次日落',
    subtitle: '每天多看一次就少一次',
    score: '8.7',
    year: '2026',
    duration: '115 分钟',
    tags: ['治愈系', '青春喜剧'],
    comments: '1.5万',
    image: 'https://readdy.ai/api/search-image?query=Warm%20orange%20sunset%20seen%20from%20a%20rooftop%20with%20city%20silhouette%2C%20soft%20cinematic%20glow%2C%20clean%20minimal%20aesthetic%20photo&width=500&height=340&seq=qpg-film-sunset&orientation=landscape',
  },
];

export const rankingFilms = [
  { id: 'r1', rank: 1, title: '盛夏的橘子树', genre: '校园片', score: '9.1', likes: '1.8万', comments: '2.4万', trend: 'up' },
  { id: 'r2', rank: 2, title: '青柠汽水', genre: '小清新', score: '8.8', likes: '1.5万', comments: '1.8万', trend: 'up' },
  { id: 'r3', rank: 3, title: '天台上的三万次日落', genre: '治愈系', score: '8.7', likes: '1.3万', comments: '1.5万', trend: 'down' },
  { id: 'r4', rank: 4, title: '樱花落下的速度', genre: '初恋电影', score: '8.9', likes: '1.6万', comments: '2.1万', trend: 'same' },
  { id: 'r5', rank: 5, title: '晚自习的猫', genre: '治愈系', score: '8.6', likes: '8900', comments: '9600', trend: 'up' },
  { id: 'r6', rank: 6, title: '旧相机里的夏天', genre: '青春怀旧', score: '8.5', likes: '9600', comments: '1.1万', trend: 'down' },
  { id: 'r7', rank: 7, title: '校服第二颗纽扣', genre: '校园片', score: '8.4', likes: '1.1万', comments: '1.2万', trend: 'same' },
  { id: 'r8', rank: 8, title: '操场尽头的告白信', genre: '清纯少女', score: '8.2', likes: '7600', comments: '8700', trend: 'up' },
  { id: 'r9', rank: 9, title: '六月的雨和你', genre: '初恋电影', score: '8.3', likes: '6800', comments: '7400', trend: 'down' },
  { id: 'r10', rank: 10, title: '毕业那天没说再见', genre: '青春怀旧', score: '8.1', likes: '6100', comments: '6900', trend: 'same' },
];

export const discussions = [
  {
    id: 'd1',
    user: '柚子同学',
    initial: '柚',
    time: '12 分钟前',
    film: '盛夏的橘子树',
    content: '看到男主把橘子放进书包那段直接破防了，我高中也做过一模一样的事，只是没敢送出去。',
    likes: '3200',
    replies: '146',
  },
  {
    id: 'd2',
    user: '晚风十三班',
    initial: '晚',
    time: '48 分钟前',
    film: '青柠汽水',
    content: '初恋电影就该拍成青柠汽水的味道吧，酸一下、凉一下，然后甜甜地没了。',
    likes: '2800',
    replies: '98',
  },
  {
    id: 'd3',
    user: '栗子不加糖',
    initial: '栗',
    time: '2 小时前',
    film: '晚自习的猫',
    content: '全班都在备考，只有那只猫假装在听讲。这不就是我本人的青春吗，躺平但可爱。',
    likes: '2100',
    replies: '73',
  },
  {
    id: 'd4',
    user: '胶片小卖部',
    initial: '胶',
    time: '5 小时前',
    film: '旧相机里的夏天',
    content: '美术指导是懂怀旧的，胶卷盒、铁皮铅笔盒、卷边的课本，每一帧都能截图当壁纸。',
    likes: '1900',
    replies: '54',
  },
  {
    id: 'd5',
    user: '橘子汽水加冰',
    initial: '橘',
    time: '昨天',
    film: '天台上的三万次日落',
    content: '建议情绪低谷的时候看，看完会想给十七岁的自己写一封信，说一声辛苦了。',
    likes: '1600',
    replies: '61',
  },
];

export const columns = [
  {
    id: 'col1',
    kicker: '观影指南',
    title: '第一次看青春片，先从这五部入门',
    excerpt: '如果你被片库刷花了眼，这份由浅入深的入门清单会帮你找到节奏，从轻松到走心，一步一步来。',
    read: '6 分钟',
    image: 'https://readdy.ai/api/search-image?query=Warm%20reading%20corner%20with%20open%20notebook%20and%20green%20plant%20by%20a%20sunny%20window%2C%20cozy%20clean%20minimal%20aesthetic%20photo&width=600&height=420&seq=qpg-col-guide&orientation=landscape',
  },
  {
    id: 'col2',
    kicker: '幕后花絮',
    title: '《青柠汽水》是怎么把夏天拍出来的',
    excerpt: '导演聊了聊如何用一台旧相机、一条老街和三十斤真橘子，拍出让人想起初恋的质感。',
    read: '9 分钟',
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20with%20old%20camera%20rig%20and%20warm%20sunlight%2C%20clean%20minimal%20cinematic%20photo%2C%20fresh%20tones&width=600&height=420&seq=qpg-col-behind&orientation=landscape',
  },
  {
    id: 'col3',
    kicker: '片单企划',
    title: '心情不好时，我们推荐这十部治愈系',
    excerpt: '没有大起大落，只有温柔。适合睡前、雨天，和需要被安慰的每一个普通夜晚。',
    read: '5 分钟',
    image: 'https://readdy.ai/api/search-image?query=Rainy%20window%20with%20green%20plants%20and%20a%20warm%20cup%20of%20tea%2C%20soft%20cozy%20minimal%20aesthetic%2C%20calm%20fresh%20tones&width=600&height=420&seq=qpg-col-heal&orientation=landscape',
  },
];

export const tagCloud = [
  '校园片', '初恋电影', '清纯少女', '小清新', '治愈系', '青春怀旧', '夏日限定',
  '同桌的你', '单车', '毕业季', '天台', '汽水', '广播站', '校服', '纸飞机',
  '海边夏天', '新人导演', '青春喜剧', '暗恋', '旧胶片',
];